import React from 'react';

function Footer() {
    // return (
    //     // <div className="col-md-12 fixed-bottom bg-dark footer-styles">
    //     //     <p className="text-center mb-0 p-2 text-white">
    //     //         © 2023 Avasoft Inc.
    //     //     </p>
    //     // </div>
    // );
}

export default Footer;
